<template>
    <div>
        <program-instructor-alert
            :instructor="instructor"
            :isRegistered="isRegistered"
        ></program-instructor-alert>
        <instructor-progress :progress="progress"></instructor-progress>
        <v-row class="mt-6">
            <v-col cols="6">
                <v-row>
                    <v-col cols="6">
                        <program-card :program="program"></program-card>
                    </v-col>
                    <v-col cols="6">
                        <sessions-card
                            :selected.sync="selectedSession"
                            :program="program"
                            :sessions="sessions"
                            @select-session="$emit('select-session', $event)"
                        ></sessions-card>
                    </v-col>
                </v-row>
                <v-row v-if="hasCreditScores" class="mt-0">
                    <v-col cols="12">
                        <credit-scores
                            :session="selectedSession"
                            :charts="charts"
                            :averages="averages"
                        ></credit-scores>
                    </v-col>
                </v-row>
            </v-col>
            <v-col cols="6">
                <students-card
                    :instructor="instructor"
                    :sessions="sessions"
                    :program="program"
                    :students="students"
                    :session="selectedSession"
                    @add-students="addStudents"
                >
                </students-card>
            </v-col>
        </v-row>
        <credit-charts
            class="mt-0"
            v-if="hasCreditCharts"
            :session="selectedSession"
            :charts="charts"
            :averages="averages"
        ></credit-charts>
    </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import InstructorProgress from "../components/ProgramInstructor/InstructorProgress.vue";
import ProgramInstructorAlert from "@/components/program/components/ProgramInstructor/ProgramInstructorAlert.vue";
import ProgramCard from "@/components/program/components/ProgramInstructor/ProgramCard.vue";
import SessionsCard from "@/components/program/components/ProgramInstructor/SessionsCard.vue";
import StudentsCard from "@/components/program/components/ProgramInstructor/StudentsCard.vue";
import CreditScores from "@/components/program/components/ProgramInstructor/CreditScores.vue";
import CreditCharts from "@/components/program/components/ProgramInstructor/CreditCharts.vue";
export default {
    name: "program-instructor",
    components: {
        InstructorProgress,
        ProgramInstructorAlert,
        ProgramCard,
        SessionsCard,
        StudentsCard,
        CreditScores,
        CreditCharts,
    },
    props: {
        instructor: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            addedStudents: [],
            selectedSession: {},
        };
    },
    computed: {
        ...mapGetters("Programs", ["dataLoading"]),
        students() {
            return this.instructor.students;
        },
        program() {
            return this.instructor.program;
        },
        charts() {
            return this.instructor.charts;
        },
        averages() {
            return this.instructor.averages;
        },
        sessions() {
            return this.instructor.sessions;
        },
        progress() {
            if (this.hasCreditCharts) {
                return "Reports";
            }
            if (this.hasStudents) {
                return "Students";
            }
            if (this.hasSession) {
                return "Sessions";
            }
            if (this.isRegistered) {
                return "Registered";
            }
            return "Invited";
        },
        isRegistered() {
            return this.$_.get(this.instructor, "meta.registered", false);
        },
        hasSessions() {
            return this.instructor.sessions.length > 0;
        },
        hasStudents() {
            return this.instructor.students.length > 0;
        },
        hasCreditScores() {
            return (
                this.$_.get(
                    this.instructor,
                    "charts.credit_score.series.data",
                    []
                ).length > 0
            );
        },
        hasCreditCharts() {
            return (
                this.$_.get(
                    this.instructor,
                    "charts.credit_balance_due.series.data",
                    []
                ).length > 0
            );
        },
    },

    methods: {
        ...mapActions("Programs", ["instructorAddStudents"]),

        addStudents(students) {
            const {
                id: instructorId,
                program: { id: programId },
            } = this.instructor;
            const sessionId = this.$_.get(
                this.instructor,
                "session.id",
                this.selectedSession.id
            );
            this.instructorAddStudents({
                instructorId,
                sessionId,
                programId,
                students,
            });
        },
    },
};
</script>
